import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { projectFilesService } from '../api/project-files.service';
import { PROJECT_FOLDER_KEYS } from './queryKeys';

export function useProjectFolders(projectId: string) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: PROJECT_FOLDER_KEYS.tree(orgId ?? '', projectId),
    queryFn: async ({ signal }) => {
      const response = await projectFilesService.getFolders(projectId, signal);
      return response.data;
    },
    staleTime: 60_000,
    enabled: !!orgId && !!projectId,
  });
}
